// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uRer","label":"styles_label__3sTWz"};